import { ScreenInventoryList } from 'sonata-platform-components';

import { useDoohInventory } from '@/context/DoohInventoryContext';
import { DoohInventoryListStyled } from './DoohInventoryList.styled';

function DoohInventoryList() {
  const { inventory, isInventoryLoading, setToggleSelectedItem } = useDoohInventory();

  return (
    <DoohInventoryListStyled>
      <ScreenInventoryList
        id="screenInventoryList"
        items={inventory}
        loading={isInventoryLoading}
        onToggleItemSelected={setToggleSelectedItem}
      />
    </DoohInventoryListStyled>
  );
}

export default DoohInventoryList;
